import { render, staticRenderFns } from "./MagicWandPanel.vue?vue&type=template&id=61fad567&"
import script from "./MagicWandPanel.vue?vue&type=script&lang=js&"
export * from "./MagicWandPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MagicWandPanel.vue"
export default component.exports